import styled from 'styled-components';

export const MobileSliderPagesStyled = styled.div`
    background-color: ${({ backgroundColor }) => backgroundColor || 'var(--color-base-secondary)'};
    min-height: 100%;
    display: flex;
    flex-direction: column;
    flex: 1 0 auto;
`;

export const MobileSliderPagesHeaderStyled = styled.div`
    display: flex;
    align-items: center;
    //overflow: hidden;
    position: relative;
    min-height: 45px;
    margin: 24px 16px 12px;

    * {
        overflow: hidden;
        text-overflow: ellipsis;
    }
`;

export const MobileSliderPagesContentStyled = styled.div`
    padding: 12px 16px 0;
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
`;

export const MobileSliderPagesHeaderContentStyled = styled.div`
    flex: 1;
    padding: 0 40px;
`;

export const MobileSliderPagesHeaderCloseButtonContainerStyled = styled.div`
    position: absolute;
    flex-grow: 0;
    flex-shrink: 0;

    &.left {
        left: 0;
    }

    &.right {
        right: 0;
    }
`;
